import { useMutation } from '@apollo/client';
import { CREATE_NOTE, UPDATE_NOTE } from '../gql/gql-note';

export function useCreateNote() {
  return useMutation(CREATE_NOTE);
}

export function useUpdateNote() {
  return useMutation(UPDATE_NOTE);
}
